import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import firebase from 'firebase'

Vue.config.productionTip = false

//fire-base
const firebaseConfig = {
  apiKey: "AIzaSyDRwY3jyyFc71MHqJxhXNYvjBKEjQuqYe4",
  authDomain: "ruby-silver-mogi.firebaseapp.com",
  databaseURL: "https://ruby-silver-mogi.firebaseio.com",
  projectId: "ruby-silver-mogi",
  storageBucket: "",
  messagingSenderId: "250845982086",
  appId: "1:250845982086:web:874d048117470213"
};

firebase.initializeApp(firebaseConfig);

new Vue({
  vuetify,router,
  render: h => h(App)
}).$mount('#app')
